import { render, staticRenderFns } from "./MentionMenuList.vue?vue&type=template&id=7e7cd138&"
import script from "./MentionMenuList.vue?vue&type=script&lang=ts&"
export * from "./MentionMenuList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports